import { Injector } from '@angular/core';
import { FeaturesService, StiggClientWrapper } from './services';
import * as Stigg from '@stigg/js-client-sdk';
import { AuthService } from '@anecdotes/auth-core';
import { WindowHelperService } from '@anecdotes/utils';

function initializeStigClient(config: Stigg.ClientConfiguration): Stigg.StiggClient {
  if (Stigg.default.initialize) {
    return Stigg.default.initialize(config);
  } else {
    return (Stigg as any).default.default.initialize(config);
  }
}

export function createFeaturesService(injector: Injector): FeaturesService {
  const authService = injector.get(AuthService);
  const windowHelper = injector.get(WindowHelperService);

  const stiggWrapper = new StiggClientWrapper(authService, windowHelper,  initializeStigClient);
  return new FeaturesService(stiggWrapper);
}
